import React from "react";
import { Routes, Route } from "react-router-dom";
import NotFoundPage from "./pages/NotFoundPage";
import HomePage from "./pages/HomePage";
import LinksPage from "./pages/links";
import CVPage from "./pages/CV/CVPage";

export default function RoutesPages() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/links" element={<LinksPage />} />
        <Route path="/resume" element={<CVPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
